import "vanilla-toast/vanilla-toast.css";
import "./style.css";

// import "core-js/stable";
// optional but required for transforming generator fns.
// import "regenerator-runtime/runtime";

import { BUOptions } from "./types";

import VanillaToast from "vanilla-toast";

const defaultOptions: BUOptions = {
  autoRun: true,
  showNotification: true,
  globalResultVarName: "isSupportedBrowser",
  notificationMessage:
    "Ihr Browser ist veraltet, bitte verwenden Sie einen aktuellen Browser",
};

const testBrowserVersion = (
  browserlistRegexp: RegExp,
  userAgent: string
): boolean => browserlistRegexp.test(userAgent);

const weirdSafariUserAgent = 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6,2 Mobile/15E148 Safari/604.1';
const isSupportedBrowser = (options: BUOptions): boolean => {
  options = { ...defaultOptions, ...options };
  if (options.browserlistRegexp === undefined) {
    console.log("No browserlist regex provided");
    return true;
  }
  const isSupported = testBrowserVersion(
    options.browserlistRegexp,
    navigator.userAgent
  ) || navigator.userAgent == weirdSafariUserAgent;
  window[options.globalResultVarName] = isSupported;

  if (!isSupported && options.showNotification) {
    VanillaToast.warning(options.notificationMessage, {
      closeButton: true,
      duration: 10000,
    });
  }
  return isSupported;
};

(() => {
  if (window.__buOptions) {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        const options: BUOptions = { ...defaultOptions, ...window.__buOptions };
        if (!options.autoRun) {
          return;
        }
        isSupportedBrowser(options);
      }, 1000);
    });
  }
})();

export {
  isSupportedBrowser,
}
